import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
	selector: 'cpi-info-alert',
	standalone: true,
	imports: [CommonModule, FontAwesomeModule],
	templateUrl: './info-alert.component.html',
	styleUrls: ['./info-alert.component.scss'],
})
export class InfoAlertComponent {
	icons = {
		faInfoCircle: faInfoCircle,
	};

	@Input() message = '';
	@Input() compact = false;
	@Input() useHtml = false;
}
